import React from 'react'
import Svg from './Svg'
export const SvgEye = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M12 4.99c-7.873 0-12 5.798-12 6.72 0 .919 4.127 6.72 12 6.72 7.872 0 12-5.801 12-6.72 0-.922-4.128-6.72-12-6.72zm0 11.888c-2.946 0-5.334-2.313-5.334-5.168S9.054 6.539 12 6.539c2.946 0 5.333 2.316 5.333 5.171 0 2.855-2.387 5.168-5.333 5.168zm0-5.168c-.488-.536.796-2.585 0-2.585-1.474 0-2.668 1.158-2.668 2.585s1.194 2.585 2.668 2.585c1.472 0 2.668-1.158 2.668-2.585 0-.656-2.253.455-2.668 0z" />
  </Svg>
))
SvgEye.isIcon = true
export default SvgEye
